import React from 'react'

import ReactDOM from 'react-dom'
import { RouterProvider } from 'react-router-dom'

import LoadingSpinner from '@components/shared/LoadingSpinner'

import routes from './routes'

ReactDOM.render(
  <React.StrictMode>
    <React.Suspense fallback={<LoadingSpinner />}>
      <RouterProvider router={routes} />
    </React.Suspense>
  </React.StrictMode>,
  document.getElementById('root')
)
